import { render, staticRenderFns } from "./SiteLicenseIdentifier.vue?vue&type=template&id=5f8e9ef4&scoped=true&"
import script from "./SiteLicenseIdentifier.vue?vue&type=script&lang=js&"
export * from "./SiteLicenseIdentifier.vue?vue&type=script&lang=js&"
import style0 from "./SiteLicenseIdentifier.vue?vue&type=style&index=0&id=5f8e9ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e9ef4",
  null
  
)

export default component.exports